export const FETCH_DYNAMIC_FORMS_SUCCESS = "FETCH_DYNAMIC_FORMS_SUCCESS";
export const REMOVE_DYNAMIC_FORM_SUCCESS = "REMOVE_DYNAMIC_FORM_SUCCESS";
export const UPDATE_DYNAMIC_FORM_SUCCESS = "UPDATE_DYNAMIC_FORM_SUCCESS";
export const GET_ALL_FORMS = "GET_ALL_FORMS";
export const REMOVE_A_FORM = "REMOVE_A_FORM";
export const UPDATE_A_FORM = "UPDATE_A_FORM";
export const RESET_DYNAMIC_FORMS = "RESET_DYNAMIC_FORMS";